import ModalSubHeader from './component.styles.js'
export default ModalSubHeader
